import ApiService from "@/core/services/api.service";

export const FETCH_SERVICE_LOCATIONS = "fetchServiceLocations";
export const FETCH_SERVICE_LOCATION = "fetchServiceLocation";
export const FETCH_SERVICE_LOCATION_TYPES = "fetchServiceLocationTypes";
export const SAVE_SERVICE_LOCATION = "saveServiceLocation";
export const UPDATE_SERVICE_LOCATION = "updateServiceLocation";
export const DELETE_SERVICE_LOCATION = "deleteServiceLocation";

export const SET_ERROR = "setServiceLocationError";
export const SET_LOADING = "setLoadingServiceLocation";

const state = {
  errors: [],
  isLoadingServiceLocation: false
};

const getters = {
  isLoadingServiceLocation() {
    return state.isLoadingServiceLocation;
  }
};

const actions = {
  [FETCH_SERVICE_LOCATIONS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-locations" + apiParams)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [FETCH_SERVICE_LOCATION](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("service-locations", id)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [FETCH_SERVICE_LOCATION_TYPES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("service-location-types")
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  },
  [SAVE_SERVICE_LOCATION](context, payload) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("service-locations", payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [UPDATE_SERVICE_LOCATION](context, params) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.update("service-locations", params.id, params.payload)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  },
  [DELETE_SERVICE_LOCATION](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("service-locations", id)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response))
        .finally(() => context.commit(SET_LOADING, false));
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingServiceLocation = false;
    state.errors = Array.isArray(errors) ? errors : [errors];
  },
  [SET_LOADING](state, value) {
    state.isLoadingServiceLocation = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
